import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../_metronic/helpers'
import { VocabularyFormModal } from './_modals/VocabularyFormModal'
import { VocabularyListModal } from './_modals/VocabularyListModal'
import { DeleteModal } from '../../components/modals/DeleteModal'
import VocabularyApi from '../../../infrastructure/api/VocabularyApi'
import { Link, Route, Switch } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../setup'
import { checkPermission, UserModel } from '../../modules/auth/models/UserModel'
import { PermissionEnum } from '../../../enums/PermissionEnum'

const VocabularyPage: FC = () => {
  const [itemId, setItemId] = useState('')
  const [itemName, setItemName] = useState('')
  const [showDelete, setShowDelete] = useState(false)
  const handleCloseDelete = () => setShowDelete(false)
  const handleShowDelete = () => setShowDelete(true)

  const [refresh, setRefresh] = useState<number>(0)
  const [showForm, setShowForm] = useState(false)
  const handleCloseForm = () => { setShowForm(false); setRefresh(refresh + 1) }
  const handleShowForm = () => setShowForm(true)

  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

  const onClickItem = (value: string, name: string, type: string) => {
    setItemId(value)
    setItemName(name)
    switch (type) {
      case 'delete':
        handleShowDelete()
        break
      default:
        handleShowForm()
        break
    }
  }

  const vocabulariesBreadCrumbs: Array<PageLink> = [
    {
      title: '',
      path: '',
      isSeparator: false,
      isActive: false,
    },
  ]
  const vocabularyBreadCrumbs: Array<PageLink> = [
    {
      title: 'Vocabularies',
      path: `/topic/vocabularies`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  async function deleteVocabulary(itemId: string) {
    var response = await VocabularyApi.DeleteVocabulary(itemId)
    setRefresh(refresh + 1)
  }

  return (
    <>
      <div className='card mb-5 mb-xl-8'>
        <Switch>
          <Route path={['/topic/vocabularies/edit/:id', '/topic/vocabularies/add']}>
            <PageTitle breadcrumbs={vocabularyBreadCrumbs}>Vocabulary</PageTitle>
            <VocabularyFormModal itemId={itemId} show={showForm} handleClose={handleCloseForm} />
          </Route>
          <Route path='/topic/vocabularies'>
            <PageTitle breadcrumbs={vocabulariesBreadCrumbs}>Vocabularies</PageTitle>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'></h3>
              {checkPermission(user, PermissionEnum.VocabularyCreate) &&
                <div
                  className='card-toolbar'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title='Click to add a vocabulary'
                >
                  <Link to={'/topic/vocabularies/add'} className='btn btn-sm btn-light-primary'>
                    <KTSVG
                      path='/media/icons/duotone/Code/Plus.svg'
                      className='svg-icon-3'
                    />
                    Add vocabulary
                  </Link>
                </div>
              }
            </div>

            <div className='card-body py-3'>
              <VocabularyListModal refresh={refresh} onClickItem={onClickItem} />
              <DeleteModal
                itemId={itemId}
                itemName={itemName}
                handleClose={handleCloseDelete}
                show={showDelete}
                type='Vocabulary'
                confirm={deleteVocabulary}
              />
            </div>
          </Route>
        </Switch>
      </div>
    </>
  )
}

const VocabularyWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>Topic</PageTitle>
      <VocabularyPage />
    </>
  )
}

export { VocabularyWrapper }
